import { Button } from "reactstrap";
import PropTypes from "prop-types";
import { RefreshButton } from "../dataTable";
import { hasAdminAccess } from "../../services/roles";
import { useSelector } from "react-redux";

export default function AdminFilterHeader({
  adminOnly,
  onButtonClick,
  onFilterChange,
  onRefresh,
  refreshing,
  buttonName,
  search,
}) {
  const user = useSelector((state) => state.user);
  return (
    <div className="cf-filters">
      <div className="cf-search">
        <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
        <input
          type="search"
          placeholder="Search…"
          value={search}
          onChange={onFilterChange}
          aria-label="Search"
        />
      </div>
      <span className="cf-filters__spacer" />
      {(hasAdminAccess(user.self) || !adminOnly) && (
        <Button color="primary" size="sm" onClick={onButtonClick}>
          <i className="fa-solid fa-plus me-1" aria-hidden="true" />
          {buttonName}
        </Button>
      )}
      <RefreshButton
        refreshing={refreshing}
        onRefresh={onRefresh}
        data-tooltip-id="tooltip"
        data-tooltip-content="Refresh"
      />
    </div>
  );
}

AdminFilterHeader.propTypes = {
  adminOnly: PropTypes.bool.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  refreshing: PropTypes.bool.isRequired,
  buttonName: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
};
